module.exports = __webpack_public_path__ + "media/images/logo/dataruma-full-27bf6a4bda0f8631d59eab0f16a938d4.svg";